import { Anchor } from "@mantine/core";

import classes from "./styles.module.css";
import { Link } from "@tanstack/react-router";

interface MenuItemProps {
  to: string;
  label: string;
  search?: { category?: number };
  onClick?: () => void;
}

function MenuItem(props: MenuItemProps) {
  return (
    <Anchor
      component={Link}
      to={props.to}
      // `to` is a runtime string, so the router cannot type the search
      // params for it. The object is passed through as-is at runtime.
      search={props.search as never}
      className={classes.menuItem}
      onClick={props.onClick}
    >
      {props.label}
    </Anchor>
  );
}

export default MenuItem;
